import { render, staticRenderFns } from "./realOpen.vue?vue&type=template&id=db216ab2&scoped=true&"
import script from "./realOpen.vue?vue&type=script&lang=js&"
export * from "./realOpen.vue?vue&type=script&lang=js&"
import style0 from "./realOpen.vue?vue&type=style&index=0&id=db216ab2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db216ab2",
  null
  
)

export default component.exports